import ConditionDesigner from "./actions/ConditionDesigner.vue";
import ConditionType from "./actions/ConditionType.js";
// import GotoDesigner from "./GotoDesigner.vue";
// import GotoType from "./GotoType.js";

import SetVariableDesigner from "./actions/SetVariableDesigner.vue";
import SetVariableType from "./actions/SetVariableType.js";
import GetDataDesigner from "./actions/GetDataDesigner.vue";
import GetDataType from "./actions/GetDataType.js";
import InsertRowDesigner from "./actions/InsertRowDesigner.vue";
import InsertRowType from "./actions/InsertRowType.js";
import UpdateRowDesigner from "./actions/UpdateRowDesigner.vue";
import UpdateRowType from "./actions/UpdateRowType.js";
import DeleteRowDesigner from "./actions/DeleteRowDesigner.vue";
import DeleteRowType from "./actions/DeleteRowType.js";
import ExecuteCommandDesigner from "./actions/ExecuteCommandDesigner.vue";
import ExecuteCommandType from "./actions/ExecuteCommandType.js";
import SendMailDesigner from "./actions/SendMailDesigner.vue";
import SendMailType from "./actions/SendMailType.js";
import SendMessageDesigner from "./actions/SendMessageDesigner.vue";
import SendMessageType from "./actions/SendMessageType.js";

export default {
    designers: {
        ConditionDesigner,
        SetVariableDesigner,
        // GotoDesigner,
        GetDataDesigner,
        InsertRowDesigner,
        UpdateRowDesigner,
        DeleteRowDesigner,
        SendMailDesigner,
        ExecuteCommandDesigner,
        SendMessageDesigner
    },

    actions: [{
            title: "General",
            types: [ConditionType, SetVariableType],
        },
        {
            title: "Data",
            types: [GetDataType, InsertRowType, UpdateRowType, DeleteRowType, ExecuteCommandType],
        },
        {
            title: "Communication",
            types: [SendMailType, SendMessageType],
        }
    ]
}